module.exports = __webpack_public_path__ + "img/lojas.54b3e785.svg";